<div class="login-screen">
  <div class="mobile-project-title">
    <img src="assets/img/skag.png" alt="SHRI KRISHNA ENGINEERING WORKS">
    <span>SHRI KRISHNA ENGINEERING WORKS</span>
  </div>

  <div class="login-card">
    <div class="login-card__loading" *ngIf="isload">
      <div class="spinner-border text-light" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div class="text-center">
      <img src="assets/img/skag.png" alt="SHRI KRISHNA ENGINEERING WORKS" class="login-logo">
    </div>

    <p class="login-badge text-center">Authorized Employee Access</p>
    <h2 class="login-title text-center">Login In<br></h2>
    

   

    <form #addForm="ngForm" (ngSubmit)="login(addForm)" class="login-form" novalidate>
      <div class="form-group">
        <label for="username">User Name</label>
        <div class="login-form__control">
          <i class='bx bx-user login-form__icon'></i>
          <input
            id="username"
            type="text"
            class="form-control"
            [(ngModel)]="addD.Username"
            name="Username"
            #Username="ngModel"
            autocomplete="username"
            placeholder="Enter your user name"
            required>
        </div>
      </div>

      <div class="form-group">
        <label for="password">Password</label>
        <div class="login-form__control login-form__control--password">
          <i class='bx bx-lock-alt login-form__icon'></i>
          <input
            id="password"
            [type]="showPassword ? 'text' : 'password'"
            class="form-control"
            [(ngModel)]="addD.Password"
            name="Password"
            #Password="ngModel"
            autocomplete="current-password"
            placeholder="Enter your password"
            required>
          <button
            type="button"
            class="login-form__toggle"
            (click)="showPassword = !showPassword"
            [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
            {{showPassword ? 'Hide' : 'Show'}}
          </button>
        </div>
      </div>

      <div class="login-form__meta">
        <span class="login-form__message" [class.login-form__message--error]="error_" [attr.role]="error_ ? 'alert' : null">
          {{error_ }}
        </span>
        <button type="button" class="login-form__link" (click)="get_Password()">Forgot password?</button>
      </div>

      <button type="submit" class="btn login-form__submit" [disabled]="btndisable || addForm.invalid">
        <span *ngIf="btndisable" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        <span>{{btndisable ? 'Signing in...' : 'Sign In'}}</span>
      </button>
    </form>

    <div class="login-extra">
      <button type="button" class="login-download" (click)="open()">Download App</button>
      <div class="login-foot-note">Secure access for approved plant users</div>
    </div>
  </div>
</div>
